import { useState, type ReactNode } from 'react';
import { HbsError, acceptInvitation } from '../api/hbs';
import { newAccountPasswordProblem, tokenFromSearch } from '../lib/invite';
import { IsianSandi } from '../components/IsianSandi';

/**
 * Menerima undangan DI DALAM Workforce.
 *
 * ADA KARENA keberatan Owner: kurir tidak seharusnya membuka CRM untuk bergabung ke aplikasi
 * absensi. Email undangan yang dikirim HBS memakai alamat CRM — itu wilayah HBS dan tidak dapat
 * diubah dari sini — jadi jalur ini dipakai lewat tautan yang disalin admin dari layar Karyawan.
 *
 * Layar ini SENGAJA berdiri di luar batas autentikasi: orang yang membukanya belum punya
 * keanggotaan, dan menuntutnya masuk lebih dulu adalah lingkaran yang tidak punya jalan keluar.
 */
export function AcceptInvitePage(): ReactNode {
  const [token] = useState(() => tokenFromSearch(window.location.search));
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  if (token === null) {
    return (
      <section className="card">
        <h2>Tautan undangan tidak lengkap</h2>
        <p className="muted small">
          Alamat ini tidak membawa kode undangan. Buka tautan yang dikirimkan kepada Anda persis
          seperti aslinya — menyalin sebagian alamat akan memotong kodenya.
        </p>
      </section>
    );
  }

  if (done) {
    return (
      <section className="card ok">
        <h2>Undangan diterima</h2>
        <p>Sekarang masuk memakai email dan kata sandi Anda.</p>
        <a className="button-primary" href="/">
          Ke layar masuk
        </a>
      </section>
    );
  }

  async function kirim(event: React.FormEvent): Promise<void> {
    event.preventDefault();
    /*
     * Nama dan kata sandi HANYA dipakai bila emailnya belum punya akun; HBS mengabaikannya bila
     * akunnya sudah ada. Karena itu keduanya OPSIONAL di sini, dan layar mengatakannya —
     * memaksa mengisi kata sandi yang akan dibuang adalah jebakan yang sudah menggigit dua kali
     * pada halaman undangan CRM.
     */
    if (password.length > 0) {
      const masalah = newAccountPasswordProblem(password, confirmation);
      if (masalah) {
        setError(masalah);
        return;
      }
    }
    setBusy(true);
    setError(null);
    try {
      await acceptInvitation({
        token: token as string,
        ...(fullName.trim() ? { fullName: fullName.trim() } : {}),
        ...(password ? { password } : {}),
      });
      setDone(true);
    } catch (sebab) {
      setError(sebab instanceof HbsError ? sebab.message : 'Tidak dapat menghubungi server.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="card" onSubmit={(e) => void kirim(e)}>
      <h2>Terima undangan</h2>
      <p className="muted small">
        Kalau email Anda <strong>sudah pernah</strong> dipakai di aplikasi kami, kosongkan kolom
        kata sandi dan pakai kata sandi lama Anda saat masuk — kata sandi yang diisi di sini tidak
        akan menggantikannya.
      </p>

      {error ? <p role="alert">{error}</p> : null}

      <label htmlFor="nama">Nama lengkap (untuk akun baru)</label>
      <input id="nama" value={fullName} onChange={(e) => setFullName(e.target.value)} />

      <label htmlFor="sandi">Kata sandi (untuk akun baru)</label>
      <IsianSandi
        id="sandi"
        autoComplete="new-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <label htmlFor="sandi-ulang">Ulangi kata sandi</label>
      <IsianSandi
        id="sandi-ulang"
        autoComplete="new-password"
        value={confirmation}
        onChange={(e) => setConfirmation(e.target.value)}
      />

      <button type="submit" className="button-primary" disabled={busy}>
        {busy ? 'Memproses…' : 'Terima undangan'}
      </button>
    </form>
  );
}
